<template >
    <div class="container">

    <!-- Outer Row -->
    <div class="row justify-content-center">

      <div class="col-xl-10 col-lg-12 col-md-9">

        <div class="card o-hidden border-0 shadow-lg my-5">
          <div class="card-body p-0">
            <!-- Nested Row within Card Body -->
            <div class="row">
              <div class="col-lg-12">
                <div class="p-5">
                  <div class="text-center">
                    <h1 v-if="this.questionId!=null && this.questionId!='' && this.questionId!='new'" class="h4 text-gray-900 mb-4">Асуулт засаx</h1>
                    <h1 v-else class="h4 text-gray-900 mb-4">Асуулт нэмэх</h1>
                  </div>
                  <form class="user">
                    <div class="form-group">
                      <label>Асуултын нэр</label>
                      <input v-model.trim="question.title" type="text" class="form-control" placeholder="Асуултын гарчиг">
                    </div>


                    <div>
                      <div v-for="(subquestion,index) in question.subquestions" >
         
                          
                          <div class="form-group">
                            <textarea v-model.trim="subquestion.description" type="text" class="form-control" id="exampleInputPassword" placeholder="Дэлгэрэнгүй" rows="10"/>
                          </div>
                          <div class="form-group">
                             <label>Асуултын оноо</label>
                            <input v-model.number="subquestion.score" type="number" class="form-control"/>
                          </div>
                          <div class="form-group">
                            <label>Асуултын хариу видео линк</label>
                            <input v-model.trim="subquestion.videoUrl" type="text" class="form-control" placeholder="Асуултын хариу видео линк">
                          </div>
                          
                          <div class="form-group">
                            
                            <label>Асуултын хариу</label>
                            <textarea v-model.trim="subquestion.solution" type="text" class="form-control"  placeholder="Асуултын хариу" rows="10"/>
                          </div>

                          <!-- <div class="form-group" v-show="!subquestion.multichoice">
                            <div class="">
                              <input type="checkbox"  v-bind:id="'answerTypeCheck_'+index" v-model="subquestion.answertype">
                              <label for="answerTypeCheck">Нээлттэй xариулт оруулаx<span class="text-info"> /Нээлттэй хариулт сонговол оюутан хүссэн хариултаа текстээр өгнө./</span></label>
                            </div>
                          </div> -->
                          <div class="form-group"  v-show="subquestion!=null && subquestion.answertype!=true">
                            <div class="">
                              <input type="checkbox"  v-bind:id="'customCheck_'+index" v-model="subquestion.multichoice">
                              <label for="customCheck" >Олон хариулттай эсэх /Multichoice/</label>
                            </div>
                          </div>
                          
                          <div class="form-group" v-show="subquestion!=null && subquestion.answertype!=true">
                            <div class="row"> 
                              <div class="col-sm-6">
                                <div class="btn btn-success btn-sm" style="cursor:pointer" v-on:click="addAnswer(subquestion)">Хариулт нэмэх</div>
                                <div class="col-sm-6 btn btn-danger btn-sm ml-3" style="cursor:pointer" v-on:click="addAnswerYESNO(subquestion)">YES/NO нэмэх</div>     
                              </div>
                            </div>
                            <hr/>
                            <div v-if="subquestion.answers!=null && subquestion.answers.length>0" >
                              <div class="row my-3"  v-for="(answer,index) in subquestion.answers" v-bind:key="'answer_'+index">
                                <div class="col col-8">
                                  <textarea  v-model.trim="answer.name" type="text" class="form-control" placeholder="Хариулт"/>
                                </div>
                                <div class="col col-2">
                                      <div class="form-check">
                                      <input type="checkbox" class="form-check-input"  v-model="answer.correct">
                                      <label class="form-check-label" for="exampleCheck1">Зөв хариулт</label>
                                    </div>
                                </div>
                                <div class="col col-2">
                                    <i class="fas fa-trash text-danger text-small" style="cursor:pointer" @click="remove(index, subquestion)"></i>
                                    Устгаx
                                </div>
                              </div>
                            </div>
                            <div v-else class="alert alert-danger">Одоогоор хариулт оруулаагүй байна.</div>
                          </div>
                        <hr/>
                      </div>
                    </div>
                    
              
                    
                    <hr/>
                    <div class="row">
                      <div class="text-center col">
                        <a class="small" href="#" @click="$router.back()">Буцах</a>
                      </div>
                      <div class="col">
                        <div @click="save" class="btn btn-primary">
                          Хадгалах
                        </div>
                      </div>
                    </div>
                    <hr>
                   
                  </form>
                  
                 
                
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

    </div>

  </div>
</template>

<script>
const fb = require('../../firebaseConfig.js')
export default {
    name: "QuestionAdd",
    data() {
        return {
          categories:[],
          selectedCategory:null,
          question: {
                title: '',
                description: '',
                subquestions:[],
                simple:true

          },

          answers:[],
          tmpAnswer:{
                'name':'',
                'correct':false
          },
        };
    },
    methods: {
      _findCategories(){
        fb.db
          .collection(this.detailPath+"/tests").orderBy("createdAt","asc")
          .onSnapshot(querySnapshot => {
            this.categories = [];
            querySnapshot.forEach(doc => {
              let cat = doc.data();
              cat.id = doc.id;
              this.categories.push(cat);
            });
          });
        this.categories.push({name:'--no group--', id:'null'});
      },
     
      save() {

        var _this = this;
            this.performingRequest = true
            if(this.question!=null && this.question.title!='' ){
                var docRef;
                if(this.questionId!=null && this.questionId!='' && this.questionId!='new'){

                  if(this.categoryId!=null && this.categoryId!='' && this.categoryId!='new'){
                    docRef = fb.db.collection(this.detailPath+"/tests").doc(this.categoryId).collection("questions").doc(this.questionId);
                  } 
                  else {
                    docRef=fb.db.collection(this.detailPath+"/questions").doc(this.questionId);
                  }
                  
                  var tmpQuestion = Object.assign({}, this.question);
                  tmpQuestion.modifiedAt=new Date();
                  delete tmpQuestion.subquestions;
                  
                  docRef.update(tmpQuestion);
                  this.question.subquestions.forEach((subquestion, sindex)=>{
                    var tmpSubQuestion = Object.assign({}, subquestion);
                    tmpSubQuestion.index=sindex;
                    tmpSubQuestion.title=this.question.title;
                    delete tmpSubQuestion.answers;
                    var subDocRef;
                    if(subquestion.id!=null && subquestion.id!='' && subquestion.id!=undefined){
                      subDocRef=docRef.collection("subquestions").doc(subquestion.id);
                      subDocRef.get().then((dtlDoc)=>{
                        if(dtlDoc.exists){
                          if(dtlDoc.data().score!=null && dtlDoc.data().score!=undefined && dtlDoc.data().score!=0 && dtlDoc.data().score!=''){
                            var value=dtlDoc.data().score;
                            fb.db.doc(this.detailPath).update({"totalScore":fb.firestore.FieldValue.increment(-(dtlDoc.data().score))});
                          }
                        }
                        subDocRef.update(tmpSubQuestion);  
                      });
   
                    }
                    else {
                      subDocRef=docRef.collection("subquestions").doc()
                      subDocRef.set(tmpSubQuestion);
                    }
                    if(subquestion.score!=undefined)
                      fb.db.doc(this.detailPath).update({"totalScore":fb.firestore.FieldValue.increment(subquestion.score)});
                    subquestion.answers.forEach((answer, index)=>{
                      answer.index=index;
                      answer.createdAt=new Date();
                      if(answer.id!=null && answer.id!='' && answer.id!=undefined)
                        subDocRef.collection("answers").doc(answer.id).update(answer);
                      else
                        subDocRef.collection("answers").doc().set(answer)
                    });
                  });
                }
                else{
                    this.question.createdAt=new Date();
                    
                    if(this.categoryId!=null && this.categoryId!='' && this.categoryId!='new'){
                      docRef = fb.db.collection(this.detailPath+"/tests").doc(this.categoryId).collection("questions").doc();
                    } 
                    else {
                      docRef=fb.db.collection(this.detailPath+"/questions").doc()
                    }
                    var tmpQuestion = Object.assign({}, this.question);
                    tmpQuestion.createdAt=new Date();
                    delete tmpQuestion.subquestions;
                    docRef.set(tmpQuestion);
                    this.question.subquestions.forEach((subquestion, sindex)=>{
                      var tmpSubQuestion = Object.assign({}, subquestion);
                      tmpSubQuestion.index=sindex;
                      delete tmpSubQuestion.answers;
                      var subDocRef=docRef.collection("subquestions").doc();
                      tmpSubQuestion.title=this.question.title;
                      
                      subDocRef.set(tmpSubQuestion);
                      if(subquestion.score!=undefined)
                        fb.db.doc(this.detailPath).update({"totalScore":fb.firestore.FieldValue.increment(subquestion.score)});
                      subquestion.answers.forEach((answer, index)=>{
                        answer.index=index;
                        answer.createdAt=new Date()
                        subDocRef.collection("answers").doc().set(answer)
                      });
                    });
                    
                }
                this.$router.back();
            }
            else{
              alert("Асуултын гарчиг болон оноог заавал оруулна");
            }
        },
        setLesson(){
          this.question={
                name: '',
                description: '',
                multichoice:false,
                answers:[]  ,
                answertype:false

            }
        },
        addSubQuestion(question){
          var tmpQuestion = Object.assign({}, {
            answers:[],
            answertype:false,
            multichoice:false,
            solution:null,
            videoUrl:null
          });
          question.subquestions.push(tmpQuestion);

        },
        addAnswer(subquestion){
          
          subquestion.answers.push({
                'name':'',
                'correct':false,
                'votedCount':0
            });
            console.log(subquestion);
        },
        addAnswerYESNO(subquestion){
          subquestion.answers.push({
                'name':'Тийм',
                'correct':false,
                'votedCount':0
          });
          subquestion.answers.push({
                'name':'Үгүй',
                'correct':false,
                'votedCount':0
          });
        },
        remove(index, subquestion){
          if(subquestion.answers!=null && subquestion.answers.length>0)
            subquestion.answers.splice(index, 1)
        },
        _getQA(){
          var _this = this;
          if(this.questionId!=null && this.questionId!='' && this.questionId!='new'){
            var docRef;
            if(this.categoryId!=null && this.categoryId!='' && this.categoryId!='new'){
              docRef = fb.db.collection(this.detailPath+"/tests").doc(this.categoryId).collection("questions").doc(this.questionId);
            } 
            else {
              docRef=fb.db.collection(this.detailPath+"/questions").doc(this.questionId);
            }

            docRef.get().then(questionDoc=>{
              let question=questionDoc.data();
              question.id=questionDoc.id;
              question.subquestions=[];

              questionDoc.ref.collection("subquestions").get().then(subDocs=>{
                subDocs.forEach((subquestion, index)=> {
                    let object=subquestion.data();
                    object.id = subquestion.id;
                    object.answers=[];

                    subquestion.ref.collection("answers").get().then(answerDocs=>{
                      answerDocs.forEach((answerDoc, index)=> {
                          let answer=answerDoc.data();
                          answer.id = answerDoc.id;
                          object.answers.push(answer);
                      });
                    });

                    question.subquestions.push(object);

                });
                if((question.subquestions!=null && question.subquestions.length==0)){
                  this.addSubQuestion(question);
                }
              });
              

              this.question=question;

            });
   
          }

        }
    },
    props: {
        questionId: { 
            required: false,
        },
        detailPath: { 
            required: true,
        },
        categoryId:{
          required: false,
        }
    },
    created() {

      if(this.questionId!=null && this.questionId!='' && this.questionId!='new'){
        this._getQA()
      }
      else{
        this.addSubQuestion(this.question);
      }
    },
};
</script>

